import { Button } from 'antd';

import './style.scss';

interface SocialNetworkButtonProps {
  icon: React.ReactNode;
  children: React.ReactNode;
  url: string;
  onClick?(): void;
  className?: string;
}

export const SocialNetworkButton = ({
  icon,
  url,
  onClick,
  children,
  className,
}: SocialNetworkButtonProps) => {
  return (
    <a href={url} target="_blank">
      <Button
        type="primary"
        size="large"
        className={`social-network-button ${className}`}
        onClick={onClick}
      >
        <div className="social-network-button__content">
          <div>{icon}</div>
          <div>{children}</div>
        </div>
      </Button>
    </a>
  );
};
